export const cn = {
  merchant: {
    Order_Overview: "订单概览",
    Payment_Information: {
      Card_Details: "卡片详情",
      LabelAmount: "支付金额",
      AmountError: "金额最多只能保留两位小数",
      fields: {
        Name_on_Card: "持卡人姓名",
        Name_on_Card_For_Ibec: "Name on Card",
        FirstName: "名",
        FirstName_For_Ibec: "First Name",
        LastName: "姓",
        LastName_For_Ibec: "Last Name",
        CardNumber: "卡号",
        Amount: "金额",
        CVV: "CVV",
        Card_Expiry: "卡片有效期",
        monthyear: "月/年",
        Memo: "备注",
        MemoPlaceholder: "备注（选填）",
      },
    },
    Appointment_Charges: "预约费用",
    Billing_Information: {
      label: "账单信息",
      fields: {
        EmailAddress: "电子邮箱",
        Phone: "电话",
        BuildingNameStreetForIBEC: "Building Name, Street",
        BuildingNameStreet: "楼宇名称、街道",
        State: "州/省",
        Select: "请选择...",
        Postal_Code_Label: "邮政编码",
        Postal_Code_Label_For_Ibec: "Postal Code",
        Postal_Code_Placeholder: "邮政编码",
        Postal_Code_Placeholder_For_Ibec: "Postal Code",
        AddressForIBEC: "Address",
        Address: "地址",
        CityStateLabel: "城市/州",
        CityStateForIBEC: "City/State",
        CityState: "城市/州",
        Country: "国家/地区",
        NoCountryFound: "未找到相关国家",
      },
    },
    button: {
      cancel: "取消",
      PayNow: "立即支付",
      GeneratePayNowQR: "生成PayNow二维码",
      GenerateQrphQR: "生成QRPH二维码",
      PayNowQR: "PayNow二维码",
      QrphQR: "QRPH二维码",
      SubscribeNow: "立即订阅",
    },
    PayNow_Scan_Hint: "请使用您的银行应用扫描此PayNow二维码进行支付",
    PayNow_Title: "PayNow支付",
    PayNow_Reference: "支付参考号",
    PayNow_Transaction_Id: "交易ID",
    PayNow_Timer_Label: "扫码支付剩余时间",
    PayNow_Timer_Expired: "二维码已过期",
    PayNow_Timer_Expired_Hint:
      "此二维码已过期。请生成新的二维码以继续支付。",
    Qrph_Scan_Hint: "请使用您的银行或电子钱包应用扫描此QRPH二维码进行支付",
    Qrph_Title: "QRPH支付",
    Qrph_Transaction_Id: "交易ID",
    Qrph_Timer_Label: "剩余扫码支付时间",
    Qrph_Timer_Expired: "二维码已过期",
    Qrph_Timer_Expired_Hint:
      "此二维码已过期。请生成新的二维码以继续支付。",
    Empty_Popup_Please_Enter_An_Amount: "请输入金额",
  },
  error404: {
    code: "错误404",
    message: "页面未找到",
    description: "抱歉，您访问的页面不存在或已被删除。",
  },
  error500: {
    code: "错误500",
    message: "服务器出现错误",
    description: "抱歉，系统出现技术问题。",
  },
  errorcancel499: {
    code: "错误499",
    message: "支付已取消",
    heading: "支付已被取消，您不会被扣款。",
    description_WithCancelUrl:
      "您的浏览器将自动跳转至商户网站。如果您不想访问该页面，可以直接关闭浏览器标签页。",
    description_WithoutCancelUrl: "您可以关闭浏览器标签页。",
  },
  error400: {
    code: "错误400",
    message: "错误请求",
    description: "抱歉，系统出现技术问题。",
  },
  Payment_Failed: {
    status: "支付失败！",
    message: "我们无法处理您的付款：",
    Prev_Link: "返回商户",
  },
  Payment_Successful: {
    status: "支付成功！",
    recipient: "收款方：",
    Amount_Paid: "支付金额：",
    Transaction_reference: "交易参考号：",
    Payment_Method: "支付方式：",
    Prev_Link: "返回商户",
    Redirect_Prefix_Text: "本页面将在",
    Redirect_Suffix_Text: "秒后自动跳转",
  },
  Validation: {
    ExpiryDate: "有效期必须晚于今天。",
    InvalidCard: "该卡无效。",
    PhoneCountryCodeRequired: "请选择国家区号。",
    PhoneDigitsOnly: "电话号码只能包含数字。",
    PhoneExactLength: "电话号码必须为{{length}}位数字。",
    PhoneLengthRange: "电话号码必须为{{min}}至{{max}}位数字。",
  },
  ProductPopup: {
    Total_Price: "总价",
  },
  Email_ID: "电子邮箱",
  Email_ID_For_Ibec: "メールアドレス",
  Email_Sent_Successfully: "邮件发送成功！",
  Please_Enter_An_Email_ID_To_Receive_The_Receipt:
    "请输入电子邮箱以接收收据：",
  Please_Enter_An_Email_ID_To_Receive_The_Receipt_For_Ibec:
    "決済完了メールを受け取りたい場合は、メールアドレスを入力して「送信」を押してください。",
  Subscription: {
    label: {
      PlanName: "套餐名称",
      BillingCycle: "账单周期",
      StartBillingDate: "账单开始日期",
      EndBillingDate: "账单结束日期",
      TrialPeriod: "试用期",
      Discount: "折扣",
      Comment: "备注",
      BillingDate: "账单日期",
      NextBillingDate: "下次账单日期",
    },
    value: {
      ForTheFirst: "前",
      Discount: "折扣",
      months: "个月",
      month: "个月",
    },
  },
  countryNames: {
    Afghanistan: "阿富汗",
    "Åland Islands": "奥兰群岛",
    Albania: "阿尔巴尼亚",
    Algeria: "阿尔及利亚",
    "American Samoa": "美属萨摩亚",
    Andorra: "安道尔",
    Angola: "安哥拉",
    Anguilla: "安圭拉",
    Antarctica: "南极洲",
    "Antigua and Barbuda": "安提瓜和巴布达",
    Argentina: "阿根廷",
    Armenia: "亚美尼亚",
    Aruba: "阿鲁巴",
    Australia: "澳大利亚",
    Austria: "奥地利",
    Azerbaijan: "阿塞拜疆",
    Bahamas: "巴哈马",
    Bahrain: "巴林",
    Bangladesh: "孟加拉国",
    Barbados: "巴巴多斯",
    Belarus: "白俄罗斯",
    Belgium: "比利时",
    Belize: "伯利兹",
    Benin: "贝宁",
    Bermuda: "百慕大",
    Bhutan: "不丹",
    Bolivia: "玻利维亚",
    "Bosnia and Herzegovina": "波斯尼亚和黑塞哥维那",
    Botswana: "博茨瓦纳",
    "Bouvet Island": "布韦岛",
    Brazil: "巴西",
    "British Indian Ocean Territory": "英属印度洋领地",
    "Brunei Darussalam": "文莱",
    Bulgaria: "保加利亚",
    "Burkina Faso": "布基纳法索",
    Burundi: "布隆迪",
    Cambodia: "柬埔寨",
    Cameroon: "喀麦隆",
    Canada: "加拿大",
    "Cape Verde": "佛得角",
    "Cayman Islands": "开曼群岛",
    "Central African Republic": "中非共和国",
    Chad: "乍得",
    Chile: "智利",
    China: "中国",
    "Christmas Island": "圣诞岛",
    "Cocos (Keeling) Islands": "科科斯（基林）群岛",
    Colombia: "哥伦比亚",
    Comoros: "科摩罗",
    Congo: "刚果共和国",
    "Congo, The Democratic Republic of the": "刚果民主共和国",
    "Cook Islands": "库克群岛",
    "Costa Rica": "哥斯达黎加",
    "Cote D'Ivoire": "科特迪瓦",
    Croatia: "克罗地亚",
    Cuba: "古巴",
    Cyprus: "塞浦路斯",
    "Czech Republic": "捷克",
    Denmark: "丹麦",
    Djibouti: "吉布提",
    Dominica: "多米尼克",
    "Dominican Republic": "多米尼加共和国",
    Ecuador: "厄瓜多尔",
    Egypt: "埃及",
    "El Salvador": "萨尔瓦多",
    "Equatorial Guinea": "赤道几内亚",
    Eritrea: "厄立特里亚",
    Estonia: "爱沙尼亚",
    Ethiopia: "埃塞俄比亚",
    "Falkland Islands (Malvinas)": "福克兰群岛（马尔维纳斯）",
    "Faroe Islands": "法罗群岛",
    Fiji: "斐济",
    Finland: "芬兰",
    France: "法国",
    "French Guiana": "法属圭亚那",
    "French Polynesia": "法属波利尼西亚",
    "French Southern Territories": "法属南部领地",
    Gabon: "加蓬",
    Gambia: "冈比亚",
    Georgia: "格鲁吉亚",
    Germany: "德国",
    Ghana: "加纳",
    Gibraltar: "直布罗陀",
    Greece: "希腊",
    Greenland: "格陵兰",
    Grenada: "格林纳达",
    Guadeloupe: "瓜德罗普",
    Guam: "关岛",
    Guatemala: "危地马拉",
    Guernsey: "根西岛",
    Guinea: "几内亚",
    "Guinea-Bissau": "几内亚比绍",
    Guyana: "圭亚那",
    Haiti: "海地",
    "Heard Island and Mcdonald Islands": "赫德岛和麦克唐纳群岛",
    "Holy See (Vatican City State)": "梵蒂冈",
    Honduras: "洪都拉斯",
    "Hong Kong": "香港",
    Hungary: "匈牙利",
    Iceland: "冰岛",
    India: "印度",
    Indonesia: "印度尼西亚",
    "Iran,Islamic Republic Of": "伊朗",
    Iraq: "伊拉克",
    Ireland: "爱尔兰",
    "Isle of Man": "马恩岛",
    Israel: "以色列",
    Italy: "意大利",
    Jamaica: "牙买加",
    Japan: "日本",
    Jersey: "泽西岛",
    Jordan: "约旦",
    Kazakhstan: "哈萨克斯坦",
    Kenya: "肯尼亚",
    Kiribati: "基里巴斯",
    "Korea, Democratic People's Republic of": "朝鲜",
    "Korea, Republic of": "韩国",
    Kuwait: "科威特",
    Kyrgyzstan: "吉尔吉斯斯坦",
    "Lao People'S Democratic Republic": "老挝",
    Latvia: "拉脱维亚",
    Lebanon: "黎巴嫩",
    Lesotho: "莱索托",
    Liberia: "利比里亚",
    "Libyan Arab Jamahiriya": "利比亚",
    Liechtenstein: "列支敦士登",
    Lithuania: "立陶宛",
    Luxembourg: "卢森堡",
    Macao: "澳门",
    "Macedonia, The Former Yugoslav Republic of": "北马其顿",
    Madagascar: "马达加斯加",
    Malawi: "马拉维",
    Malaysia: "马来西亚",
    Maldives: "马尔代夫",
    Mali: "马里",
    Malta: "马耳他",
    "Marshall Islands": "马绍尔群岛",
    Martinique: "马提尼克",
    Mauritania: "毛里塔尼亚",
    Mauritius: "毛里求斯",
    Mayotte: "马约特",
    Mexico: "墨西哥",
    "Micronesia, Federated States of": "密克罗尼西亚联邦",
    "Moldova, Republic of": "摩尔多瓦",
    Monaco: "摩纳哥",
    Mongolia: "蒙古",
    Montserrat: "蒙特塞拉特",
    Morocco: "摩洛哥",
    Mozambique: "莫桑比克",
    Myanmar: "缅甸",
    Namibia: "纳米比亚",
    Nauru: "瑙鲁",
    Nepal: "尼泊尔",
    Netherlands: "荷兰",
    "Netherlands Antilles": "荷属安的列斯",
    "New Caledonia": "新喀里多尼亚",
    "New Zealand": "新西兰",
    Nicaragua: "尼加拉瓜",
    Niger: "尼日尔",
    Nigeria: "尼日利亚",
    Niue: "纽埃",
    "Norfolk Island": "诺福克岛",
    "Northern Mariana Islands": "北马里亚纳群岛",
    Norway: "挪威",
    Oman: "阿曼",
    Pakistan: "巴基斯坦",
    Palau: "帕劳",
    "Palestinian Territory, Occupied": "巴勒斯坦",
    Panama: "巴拿马",
    "Papua New Guinea": "巴布亚新几内亚",
    Paraguay: "巴拉圭",
    Peru: "秘鲁",
    Philippines: "菲律宾",
    Pitcairn: "皮特凯恩群岛",
    Poland: "波兰",
    Portugal: "葡萄牙",
    "Puerto Rico": "波多黎各",
    Qatar: "卡塔尔",
    Reunion: "留尼汪",
    Romania: "罗马尼亚",
    "Russian Federation": "俄罗斯",
    RWANDA: "卢旺达",
    "Saint Helena": "圣赫勒拿",
    "Saint Kitts and Nevis": "圣基茨和尼维斯",
    "Saint Lucia": "圣卢西亚",
    "Saint Pierre and Miquelon": "圣皮埃尔和密克隆",
    "Saint Vincent and the Grenadines": "圣文森特和格林纳丁斯",
    Samoa: "萨摩亚",
    "San Marino": "圣马力诺",
    "Sao Tome and Principe": "圣多美和普林西比",
    "Saudi Arabia": "沙特阿拉伯",
    Senegal: "塞内加尔",
    "Serbia and Montenegro": "塞尔维亚和黑山",
    Seychelles: "塞舌尔",
    "Sierra Leone": "塞拉利昂",
    Singapore: "新加坡",
    Slovakia: "斯洛伐克",
    Slovenia: "斯洛文尼亚",
    "Solomon Islands": "所罗门群岛",
    Somalia: "索马里",
    "South Africa": "南非",
    "South Georgia and the South Sandwich Islands": "南乔治亚和南桑威奇群岛",
    Spain: "西班牙",
    "Sri Lanka": "斯里兰卡",
    Sudan: "苏丹",
    Surilabel: "苏里南",
    "Svalbard and Jan Mayen": "斯瓦尔巴和扬马延",
    Swaziland: "斯威士兰",
    Sweden: "瑞典",
    Switzerland: "瑞士",
    "Syrian Arab Republic": "叙利亚",
    "Taiwan, Province of China": "中国台湾",
    Tajikistan: "塔吉克斯坦",
    "Tanzania, United Republic of": "坦桑尼亚",
    Thailand: "泰国",
    "Timor-Leste": "东帝汶",
    Togo: "多哥",
    Tokelau: "托克劳",
    Tonga: "汤加",
    "Trinidad and Tobago": "特立尼达和多巴哥",
    Tunisia: "突尼斯",
    Turkey: "土耳其",
    Turkmenistan: "土库曼斯坦",
    "Turks and Caicos Islands": "特克斯和凯科斯群岛",
    Tuvalu: "图瓦卢",
    Uganda: "乌干达",
    Ukraine: "乌克兰",
    "United Arab Emirates": "阿拉伯联合酋长国",
    "United Kingdom": "英国",
    "United States": "美国",
    "United States Minor Outlying Islands": "美国本土外小岛屿",
    Uruguay: "乌拉圭",
    Uzbekistan: "乌兹别克斯坦",
    Vanuatu: "瓦努阿图",
    Venezuela: "委内瑞拉",
    "Viet Nam": "越南",
    "Virgin Islands, British": "英属维尔京群岛",
    "Virgin Islands, U.S.": "美属维尔京群岛",
    "Wallis and Futuna": "瓦利斯和富图纳",
    "Western Sahara": "西撒哈拉",
    Yemen: "也门",
    Zambia: "赞比亚",
    Zimbabwe: "津巴布韦",
  },
  infoText: {
    name: "姓名不能包含特殊字符或数字。",
    email: "电子邮箱不能超过45个字符",
    special: "电话号码和邮政编码中不允许使用特殊字符",
    phone: "电话号码不能超过15位数字",
    address: "地址不能超过199个字符",
    city: "城市/州不能超过20个字符",
    postalCode: "邮政编码不能超过10个字符",
    memo: "备注不能超过255个字符",
  },
  countryCode: {
    JPY: "JPY",
    USD: "USD",
    HKD: "HKD",
    SGD: "SGD",
    PHP: "PHP",
  },
  "Send Email": "发送邮件",
  "Send Email_For_Ibec": "送信",
  "Or Pay With Card": "或使用银行卡支付",
  "From The Button Below": "下記のボタンから",
  "You Can Also Pay": "決済することもできます",
  "Enable Apple Pay Text": `Appleアカウントに登録のクレジットカード情報を使用してお支払いできます。ご利用できるカードブランドは、<span style="color:red">Visa・Mastercard</span>です。`,
  "Enable Google Pay Text": `Googleアカウントに登録のクレジットカード情報を使用してお支払いできます。ご利用できるカードブランドは、<span style="color:red">Visa・Mastercard</span>です。`,
  "Apple Pay inactive on your device.": "您的设备无法使用Apple Pay。",
};
